import { recipesIdsKillSwitchList } from './useProsCollection';

const useExperimentationForRvi = async ({ _properties = {}, expSdk }) => {
  let setKillSwitchUsingExperimentation;
  const properties = { ..._properties };
  const entryPoint = process.env.ENTRY_POINT;

  try {
    const module = await import('../utils/killSwitchUtil');
    setKillSwitchUsingExperimentation = module.setKillSwitchUsingExperimentation;
  } catch (err) {
    throw new Error('Module load failed');
  }

  recipesIdsKillSwitchList[entryPoint].forEach((item) => {
    setKillSwitchUsingExperimentation(
      item.recipeId,
      item.ksName,
      properties,
      expSdk,
    );
  });

  return { properties };
};

export default useExperimentationForRvi;
